/** Как Offer.setGoals — amount из offers/v2 может прийти строкой. */
export function parseOfferMoneyAmount(value: unknown): number | null {
    if (value == null || value === '') {
        return null;
    }

    const amount = parseFloat(String(value));

    return Number.isNaN(amount) ? null : amount;
}

/**
 * Сырое значение поля «План» (@change / @clear BaseInputNumber).
 * Пустая строка / null → null (удалили всё); «0» / 0 → 0 (явный ноль).
 * Не использовать update:value после пустого blur — там BaseInputNumber подставляет 0.
 */
export function parseContestPlanFieldValue(value: unknown): number | null {
    if (value == null || value === '') {
        return null;
    }

    return parseOfferMoneyAmount(value);
}

/**
 * Сохранённый план нельзя сбросить в null (API не принимает custom_goal: null).
 * Clear в UI оставляет null в draft → canSave / валидация блокируют подтверждение.
 */
export function isContestSavedPlanCleared(
    hadSavedPlan: boolean,
    plan: number | null | undefined,
): boolean {
    return hadSavedPlan && parseOfferMoneyAmount(plan) == null;
}
